export {
  faArrowLeft,
  faCheck,
  faDownload,
  faEdit,
  faEllipsisVAlt,
  faExternalLink,
  faLongArrowRight,
  faPaperPlane,
  faPlus,
  faSave,
  faShoppingCart,
  faStar,
  faTimes,
  faTrash,
  faTrashAlt,
  faUser,
  faWind,
} from '@fortawesome/pro-light-svg-icons';
